import { FC } from 'react';
import { Field } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { Link } from '@mui/icons-material';
import { InputAdornment } from '@mui/material';

import FormSelect from '@components/FormSelect/FormSelect';
import FormTextField from '@components/FormTextField/FormTextField';
import useSupplementCategories from '@store/hooks/useSupplementCategories';
import removeWhiteSpaces from '@utils/removeWhiteSpaces';

import { IUserEnteredSupplementFormProps } from './UserEnteredSupplementForm.interface';

import './style.scss';

const UserEnteredSupplementForm: FC<IUserEnteredSupplementFormProps> = ({
  disabled,
  handleSubmit,
}) => {
  const { t } = useTranslation();

  const supplementCategories = useSupplementCategories();

  return (
    <form
      className="user-entered-supplement-form"
      id="user-entered-supplement-form"
      noValidate
      onSubmit={handleSubmit}
    >
      <p className="user-entered-supplement-form__required small">{t('common.required')}</p>

      <Field
        component={FormTextField}
        className="user-entered-supplement-form__input"
        label={t('addSupplementModal.supplementName')}
        name="supplementName"
        disabled={disabled}
        maxRows={2}
        format={removeWhiteSpaces}
        formatOnBlur
        multiline
        required
      />

      <Field
        component={FormTextField}
        className="user-entered-supplement-form__input"
        label={t('addSupplementModal.companyName')}
        name="companyName"
        disabled={disabled}
        format={removeWhiteSpaces}
        formatOnBlur
        multiline
        required
      />

      <Field
        component={FormSelect}
        className="user-entered-supplement-form__input"
        label={t('addSupplementModal.productCategory')}
        name="supplementCategoryId"
        options={supplementCategories}
        disabled={disabled}
      />

      <Field
        component={FormTextField}
        className="user-entered-supplement-form__input user-entered-supplement-form__link"
        label={t('addSupplementModal.linkToProductPage')}
        name="linkToProductPage"
        disabled={disabled}
        InputProps={{
          startAdornment: (
            <InputAdornment className="user-entered-supplement-form__input-icon" position="start">
              <Link color="inherit" />
            </InputAdornment>
          ),
        }}
        format={removeWhiteSpaces}
        formatOnBlur
        required
      />
    </form>
  );
};

export default UserEnteredSupplementForm;
